import { connect } from "react-redux";
import AppButtonGroup from "./AppButtonGroup.component";

function mapStateToProps(state) {
  return {
    themeColor: "#005646",
  };
}

export default connect(mapStateToProps)(AppButtonGroup);
